export default "__VITE_ASSET__24a4ee4d__"